export default __webpack_public_path__ + "static/media/nextarrow.1c0cb911.svg";